import React from 'react';
import { PropTypes as PT } from 'prop-types';
import { injectIntl, defineMessages } from 'react-intl';
import { Field, reduxForm } from 'redux-form';
import onClickOutside from 'react-onclickoutside';
import { ReactComponent as SearchIcon } from '@lifesize/ux-assets/vectors/svgIcons/search.svg';
import { GLOBAL_SEARCH_FORM } from 'constants/Header';
import classes from './GlobalSearchBar.module.scss';

const messages = defineMessages({
  search: { id: 'components.header.search', defaultMessage: 'Search Directory' }
});

export class GlobalSearchBar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      focused: false,
      placeholderText: props.intl.formatMessage(messages.search)
    };
    this.resolveFocus = this.resolveFocus.bind(this);
    this.focus = this.focusHandler.bind(this);
  }

  componentDidMount() {
    this.searchInput.getRenderedComponent().addEventListener('transitionend', this.resolveFocus);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (!this.state.focused) {
      this.setState({
        placeholderText: nextProps.intl.formatMessage(messages.search)
      });
    }
  }

  UNSAFE_componentWillUpdate(nextProps) {
    if (nextProps.blurred) {
      this.setState({
        focused: false,
        placeholderText: this.props.intl.formatMessage(messages.search)
      });
    }
  }

  componentDidUpdate() {
    if (this.props.blurred) {
      document.getElementById('globalSearch').blur();
      this.props.blurInput();
    }
  }

  componentWillUnmount() {
    this.searchInput.getRenderedComponent().removeEventListener('transitionend', this.resolveFocus);
  }

  resolveFocus() {
    if (this.state.focused) {
      this.props.handleSetIsFocused(true);
    }
  }

  focusHandler() {
    this.setState({
      focused: true,
      placeholderText: ''
    });
  }

  handleClickOutside(evt) {
    const targetClass = evt.target.className || '';

    if (typeof targetClass === 'string' && !targetClass.toLowerCase().includes('globalsearch')) {
      this.setState({
        focused: false,
        placeholderText: this.props.intl.formatMessage(messages.search)
      });
    }
  }

  render() {
    return (
      <div className={this.state.focused ? `${classes.searchWrapper} ${classes.focused}` : classes.searchWrapper}>
        <Field
          className={this.state.focused ? `${classes.mainSearch} ${classes.focused}` : classes.mainSearch}
          component="input"
          disabled={this.props.disabled}
          forwardRef
          id="globalSearch"
          maxLength={64}
          name="globalSearch"
          onFocus={this.focus}
          placeholder={this.state.placeholderText}
          ref={(comp) => {
            this.searchInput = comp;
          }}
          type="text"
        />
        <SearchIcon className={classes.searchIcon} />
      </div>
    );
  }
}

GlobalSearchBar.propTypes = {
  blurInput: PT.func,
  blurred: PT.bool,
  disabled: PT.bool,
  handleSetIsFocused: PT.func.isRequired,
  intl: PT.object
};

export default reduxForm({
  form: GLOBAL_SEARCH_FORM,
  getFormState: (state) => state.app.form
})(injectIntl(onClickOutside(GlobalSearchBar)));
